export function fieldOrDash(v) { return v || "—"; }

export function aggregateByType(items) {
  const agg = {};
  for (const it of items || []) {
    const key = it.type || "Genérico";
    if (!agg[key]) agg[key] = { type: key, items: [], total_cups: 0, total_qty: 0, by_color: {} };
    agg[key].items.push(it);
    agg[key].total_cups += it.cups || 0;
    agg[key].total_qty += it.qty || 0;
    for (const cb of it.color_breakdown || []) {
      agg[key].by_color[cb.color] = (agg[key].by_color[cb.color] || 0) + cb.qty;
    }
  }
  return Object.values(agg).sort((a, b) => b.total_cups - a.total_cups);
}

// Checklist obrigatório para enviar à produção (por item do pedido)
export function missingProductionInfo(order, orderImageUrl, orderSilk) {
  const items = order?.order_items || [];
  if (items.length === 0) {
    return [{ sku: "Pedido", name: "Pedido sem itens", missing: ["Tipo de produto", "Quantidade de produtos", "Cor de copo", "Cor do silk", "Imagem da arte"] }];
  }
  const result = [];
  items.forEach((it, i) => {
    const missing = [];
    if (!it.type || it.type === "Genérico") missing.push("Tipo de produto");
    if (!(it.qty > 0)) missing.push("Quantidade de produtos");
    if (!(it.color_breakdown || []).some((cb) => (cb.qty || 0) > 0)) missing.push("Cor de copo");
    if (!it.silk_color && !orderSilk) missing.push("Cor do silk");
    if (!it.image_url && !orderImageUrl) missing.push("Imagem da arte");
    if (missing.length) result.push({ sku: it.sku || `Item ${i + 1}`, name: it.name, missing });
  });
  return result;
}

export function itemColorStatus(it) {
  const allocated = (it.color_breakdown || []).reduce((s, b) => s + (b.qty || 0), 0);
  if (allocated === 0) return { label: "Sem cor definida", color: "#FFC000", complete: false };
  if (allocated === it.cups) return { label: `${it.color_breakdown.length} cores definidas`, color: "#00A300", complete: true };
  return { label: `${allocated}/${it.cups} distribuídos`, color: "#E60000", complete: false };
}
